import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const visibleKeys: TRevenueSnapshotKeys[] = [
  'RevenuePolySouthMiddleEuropeAndAfrica',
  'RevenuePolyCentralEastEurope',
  'RevenuePolyNorthEurope',
  'RevenuePolyAsia',
  'RevenuePolyIndiaAndBSL',
  'RevenuePolyChina',
  'RevenuePolyLatinAmerica',
  'RevenuePolyNorthAmerica',
  'PolyByMarketsTotal',
]

export const keyField = 'Key'
